module.exports = __webpack_public_path__ + "assets/img/b66d5cca232f9bbf3bb0f16e4e2e51af.svg";